import React, { useContext, useRef, useState } from "react";
import CenterIcon from "../components/ui/CenterIcon";
import { description, printRelativeDate, printUnit } from "../utils/ar";
import CommunityCreateCommentForm from "./CommunityCreateCommentForm";
import CommunityCommentCard from "./CommunityCommentCard";
import AuthContext from "../context/AuthContext";
import Button from "../components/ui/Button";
import auth from "../services/authServices";
import http from "../services/httpServices";
import LoadingIcon from "../components/ui/LoadingIcon";
import { baseURL } from "../config";
import { showPicture } from "../services/contentServices";
import { ReactComponent as PrivateIcon } from "../assets/Updated-imagery/privateuser.svg";

const CommunityPostCard = ({ post, posts, setPosts, category, setCategory }) => {
    const { adminToken, user } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true);

    const imageSrcRef = useRef();

    const handlePostAction = async (action = "approve") => {
        const token = auth.getAdminToken();
        const config = auth.getAuthConfig(token);
        setIsLoading(true);

        try {
            if (action === "delete") {
                const { data } = await http.delete(
                    `/api/community/community_categories/${category.id}/posts/${post.id}`,
                    config
                );
                let communinty_category_pending_posts = category.community_posts.filter(
                    (value) => value.id !== post.id
                );
                setCategory({
                    ...category,
                    community_posts: [...communinty_category_pending_posts],
                });

                let newPosts = posts.filter((value) => value.id !== post.id);

                setPosts([...newPosts]);
            } else if (action === "approve") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/approve`,
                    {},
                    config
                );
                let newPost = category.community_posts.filter((value) => value.id === post.id);
                newPost[0].is_approved = true;
                let communinty_category_pending_posts = category.community_posts.filter(
                    (value) => value.id !== post.id
                );
                setCategory({
                    ...category,
                    community_posts: [...communinty_category_pending_posts],
                });
                let newPosts = [...newPost, ...posts];
                setPosts(newPosts);
            } else if (action === "closecomments") {
                // Toggle the `is_closed` status of the post
                const { data: updatedPost } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/${
                        post.is_closed ? "open" : "close"
                    }`,
                    { is_closed: !post.is_closed },
                    config
                );
                const updatedPosts = posts.map((p) =>
                    p.id === post.id ? { ...p, is_closed: updatedPost.is_closed } : p
                );
                setPosts(updatedPosts);

                const updatedCommunityPosts = category.community_posts.map((p) =>
                    p.id === post.id ? { ...p, is_closed: updatedPost.is_closed } : p
                );
                setCategory({
                    ...category,
                    community_posts: updatedCommunityPosts,
                });
            } else if (action === "pinPost") {
                // Toggle the `is_pinned` status of the post
                const { data: updatedPost } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/${
                        post.is_pinned ? "unpin" : "pin"
                    }`,
                    { is_pinned: !post.is_pinned },
                    config
                );
                const updatedPosts = posts.map((p) =>
                    p.id === post.id ? { ...p, is_pinned: updatedPost.is_pinned } : p
                );
                setPosts(updatedPosts);

                const updatedCommunityPosts = category.community_posts.map((p) =>
                    p.id === post.id ? { ...p, is_pinned: updatedPost.is_pinned } : p
                );
                setCategory({
                    ...category,
                    community_posts: updatedCommunityPosts,
                });
            } else if (action === "makeprivate") {
                // Toggle the `is_closed` status of the post
                const { data: updatedPost } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/private`,
                    { is_private: !post.is_private },
                    config
                );
                const updatedPosts = posts.map((p) =>
                    p.id === post.id ? { ...p, is_private: updatedPost.is_private } : p
                );
                setPosts(updatedPosts);

                const updatedCommunityPosts = category.community_posts.map((p) =>
                    p.id === post.id ? { ...p, is_private: updatedPost.is_private } : p
                );
                setCategory({
                    ...category,
                    community_posts: updatedCommunityPosts,
                });
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    return (
        <div className="bg-primary-container clr-text-primary smooth rounded-2xl">
            <div className="flex justify-between items-center w-full">
                <div className="flex-center-both p-2 space-x-2 space-x-reverse">
                    <div className="sm:w-10 w-7 sm:h-10 h-7 rounded-full bg-orange-100 dark:bg-orange-700 flex-center-both smooth">
                        <CenterIcon
                            className="w-full h-full text-orange-800 dark:text-orange-400 smooth "
                            iconProperties={{ className: "h-3/4 w-3/4" }}
                            icon="iconamoon:profile-fill"
                        />
                    </div>
                    {/* <div className="">{post.user.full_name}</div> */}
                    <div className="space-y-1">
                        <div className="font-w-bold">{post.user.full_name}</div>
                        <div className="clr-text-secondary smooth font-smaller flex space-x-1 space-x-reverse">
                            <CenterIcon icon="icon-park-twotone:time" className="pt-0.5" />
                            <span>
                                {printRelativeDate(post.created_at)}
                                {post.is_approved ? (
                                    ""
                                ) : (
                                    <>
                                        {" - "}
                                        <span className="text-orange-500 opacity-70 underline">
                                            قيد المراجعة
                                        </span>
                                    </>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                {adminToken ? (
                    <>
                        <div className="px-5">
                            <div className="h-0.5 bg-cyan-700 w-full rounded-md smooth"></div>
                        </div>
                        <div className="flex-center-both space-x-2 space-x-reverse mx-3 py-2">
                            <Button
                                className="flex items-center py-1 px-2 group"
                                onClick={() => handlePostAction("makeprivate")}
                                color="yellow"
                            >
                                {/* <PrivateIcon className="w-7 h-7 fill-white group-hover:fill-yellow-500 smooth" /> */}
                                {post.is_private ? "إلغاء الخصوصية" : "فعّل الخصوصية"}
                            </Button>

                            <Button
                                className="flex items-center py-1 px-2 group"
                                onClick={() => handlePostAction("pinPost")}
                                color={!post.is_pinned ? "rose" : "emerlad"}
                            >
                                {/* <PrivateIcon className="w-7 h-7 fill-white group-hover:fill-yellow-500 smooth" /> */}
                                {!post.is_pinned ? "تثبيت الموضوع" : "الغاء تثبيت الموضوع"}
                            </Button>
                            <Button
                                className="flex items-center py-1 px-2 group"
                                onClick={() => handlePostAction("closecomments")}
                                color={post.is_closed ? "orange" : "slate"}
                            >
                                {post.is_closed ? "فتح الموضوع" : "غلق الموضوع"}
                            </Button>
                            {post.is_approved ? (
                                <Button
                                    color="rose"
                                    onClick={() => handlePostAction("delete")}
                                    isLoading={isLoading}
                                >
                                    حذف
                                </Button>
                            ) : null}
                        </div>
                    </>
                ) : (
                    ""
                )}
            </div>
            <div className="px-5">
                <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
            </div>

            <div className="py-5 sm:px-2 px-5">{description(post.description, true)}</div>
            {post.image_source ? (
                <div className="py-5">
                    <div className="w-full rounded-md relative overflow-hidden text-center h-[400px]">
                        <img
                            src={`${baseURL}/${post.image_source}`}
                            alt="course"
                            ref={imageSrcRef}
                            onLoad={() => {
                                setIsImageLoading(false);
                            }}
                            className={` ${
                                isImageLoading ? "hidden " : ""
                            } h-full max-w-full mx-auto cursor-pointer`}
                            onClick={() => showPicture(imageSrcRef.current.src, false)}
                        />
                        {isImageLoading ? (
                            <div className="h-full bg-slate-300 dark:bg-slate-50/10 flex-center-both font-h1 font-w-bold">
                                <div className="flex flex-row space-x-3 space-x-reverse">
                                    <LoadingIcon className={"font-big text-blue-500"} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                ""
            )}

            {post.is_approved ? (
                <>
                    <div className="px-5">
                        <div className="flex items-center justify-end">
                            <div className="font-smaller clr-text-secondary smooth py-2">
                                {printUnit(post.community_comments.length, "تعليق")}
                            </div>
                        </div>
                    </div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="py-2 flex-center-both clr-text-secondary smooth">التعليقات</div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="space-y-5">
                        {post.is_private && post.user.email !== user.email && !adminToken ? (
                            <div className="flex-center-both p-4 gap-2">
                                <CenterIcon icon="material-symbols-light:comments-disabled-rounded" />
                                <p className="text-red-500">
                                    هذا الموضوع خاص بالطالب {post.user.full_name} ولا يمكنك الرد
                                    عليه.
                                </p>
                            </div>
                        ) : post.is_closed ? (
                            <div className="flex-center-both p-4 gap-2">
                                <CenterIcon icon="material-symbols-light:comments-disabled-rounded" />
                                <p className="text-red-500">التعليقات مغلقة لهذا الموضوع.</p>
                            </div>
                        ) : (
                            <CommunityCreateCommentForm
                                posts={posts}
                                setPosts={setPosts}
                                category={category}
                                post={post}
                            />
                        )}
                        <div className="p-2">
                            <div className="sm:px-7 px-6 bg-third-container rounded-md py-4 space-y-2">
                                {post.community_comments.map((comment) => {
                                    return (
                                        <CommunityCommentCard
                                            posts={posts}
                                            setPosts={setPosts}
                                            category={category}
                                            post={post}
                                            key={comment.id}
                                            comment={comment}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </>
            ) : adminToken ? (
                <>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="flex-center-both space-x-2 space-x-reverse py-2">
                        <Button
                            color="royalBlue"
                            onClick={() => handlePostAction("approve")}
                            isLoading={isLoading}
                        >
                            قبول الموضوع و نشره
                        </Button>
                        <Button
                            color="rose"
                            onClick={() => handlePostAction("delete")}
                            isLoading={isLoading}
                        >
                            حذف الموضوع
                        </Button>
                    </div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="space-y-5">
                        {post.is_private && post.user.email != user.email && !adminToken ? (
                            <div className="flex-center-both p-4 gap-2">
                                <CenterIcon icon="material-symbols-light:comments-disabled-rounded" />
                                <p className="text-red-500">
                                    هذا الموضوع خاص بالطالب {post.user.full_name} ولا يمكنك الرد
                                    عليه.
                                </p>
                            </div>
                        ) : post.is_closed ? (
                            <div className="flex-center-both p-4 gap-2">
                                <CenterIcon icon="material-symbols-light:comments-disabled-rounded" />
                                <p className="text-red-500">التعليقات مغلقة لهذا الموضوع.</p>
                            </div>
                        ) : (
                            <CommunityCreateCommentForm
                                posts={category.community_posts}
                                setPosts={(posts) => {
                                    // let newCommunityPosts =
                                    setCategory({
                                        ...category,
                                        community_posts: posts,
                                    });
                                }}
                                category={category}
                                post={post}
                            />
                        )}

                        <div className="p-2">
                            <div className="sm:px-7 px-6 bg-third-container rounded-md py-4 space-y-2">
                                {post.community_comments.map((comment) => {
                                    return (
                                        <CommunityCommentCard
                                            posts={posts}
                                            setPosts={setPosts}
                                            category={category}
                                            post={post}
                                            key={comment.id}
                                            comment={comment}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                ""
            )}
        </div>
    );
};

export default CommunityPostCard;
